// OwnClientCard's read (finance-real, the user 2026-10-22): which client is the agency's own (TD-105), main's route.
import type { UseQueryResult } from "@tanstack/react-query";
import { useOwnClient } from "../../hooks/useLedger";
import type { OwnClient } from "../../types";

export interface OwnClientCardModel {
  own: UseQueryResult<OwnClient>;
}

export function useOwnClientCard(): OwnClientCardModel {
  return { own: useOwnClient() };
}
